import {
    IS_FIXTURE_LOADING,
    FIXTURE_HAS_ERROR,
    FIXTURE_FETCH_DATA_SUCCESS,
    IS_USER_PLAYED_GAME_DAYS_LOADING,
    USER_PLAYED_GAME_DAYS_HAS_ERROR,
    USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS,
    IS_GET_TEAM_LOADING,
    GET_TEAM_HAS_ERROR,
    GET_TEAM_FETCH_DATA_SUCCESS,
    CREATE_MANAGE_TEAM_SKELETON,
    RESET_TRANSFERS,
    GET_USER_SPECIFIC_FIXTURES,
    SUBSTITUTE_THIS_PLAYER,
    UPDATE_CURRENT_ACTIVE_FIXTURE,
    REPLACE_WITH_THIS_PLAYER,
    RESET_TEAM_DATA,
    RESET_CREATE_TEAM_ERROR,
    CANCEL_SUBSTITUTION,
    RESET_SUBSTITUTION,
    REMOVE_ALL,
    IS_MATCH_DETAILS_LOADING,
    MATCH_DETAILS_HAS_ERROR,
    MATCH_DETAILS_FETCH_DATA_SUCCESS,

} from './../constants/action-types';
import config from './../config';
import common from './../common';
import {
    fixtures,
    userPlayedGameDays,
    getTeam,
    matchDetailsAPI,
} from "../constants/api-url";

export function isFixtureLoading(bool) {
    return {
        type: IS_FIXTURE_LOADING,
        payload: bool
    };
}

export function fixtureHasError(bool) {
    return {
        type: FIXTURE_HAS_ERROR,
        payload: bool
    };
}

export function fixtureFetchDataSuccess(fixtures) {
    return {
        type: FIXTURE_FETCH_DATA_SUCCESS,
        payload: fixtures
    };
}

export function isGetTeamLoading(bool) {
    return {
        type: IS_GET_TEAM_LOADING,
        payload: bool
    };
}

export function getTeamHasError(bool) {
    return {
        type: GET_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function getTeamFetchDataSuccess(userTeam) {
    return {
        type: GET_TEAM_FETCH_DATA_SUCCESS,
        payload: userTeam
    };
}

export function isUserPlayedGameDaysLoading(bool) {
    return {
        type: IS_USER_PLAYED_GAME_DAYS_LOADING,
        payload: bool
    };
}

export function userPlayedGameDaysHasError(bool) {
    return {
        type: USER_PLAYED_GAME_DAYS_HAS_ERROR,
        payload: bool
    };
}

export function userPlayedGameDaysFetchDataSuccess(userPlayedGameDays) {
    return {
        type: USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS,
        payload: userPlayedGameDays
    };
}

export function getFixtures(matchDayID) {
    let params = {
        matchdayId: matchDayID || 0,
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(fixtures, dispatch, isFixtureLoading, fixtureFetchDataSuccess, fixtureHasError, params);
}

export function getUserPlayedGameDays(guid) {
    const userPlayedGameDaysAPI = userPlayedGameDays.replace('{GUID}', guid || 0);
    return (dispatch) => common.makeAPICall(userPlayedGameDaysAPI, dispatch, isUserPlayedGameDaysLoading, userPlayedGameDaysFetchDataSuccess, userPlayedGameDaysHasError);
}

export function getUserTeamOfMatchDay(guid, gamedayId, phaseId) {
    const getTeamAPI = getTeam.replace('{GUID}', guid || 0);
    let params = {
        optType: 1,
        gamedayId: gamedayId,
        phaseId: phaseId,
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(getTeamAPI, dispatch, isGetTeamLoading, getTeamFetchDataSuccess, getTeamHasError, params);
}

export function createManageTeamSkeleton() {
    return {
        type: CREATE_MANAGE_TEAM_SKELETON,
        payload: null
    };
}

export function resetTransfers() {
    return {
        type: RESET_TRANSFERS,
        payload: null
    };
}

export function getUserSpecificFixtures(matchDayID) {
    return {
        type: GET_USER_SPECIFIC_FIXTURES,
        payload: matchDayID
    };
}

export function updateCurrentActiveFixture(index) {
    return {
        type: UPDATE_CURRENT_ACTIVE_FIXTURE,
        payload: index
    };
}

export function initiateSubstitution(player) {
    return {
        type: SUBSTITUTE_THIS_PLAYER,
        payload: player
    };
}

export function resetSubstitution() {
    return {
        type: RESET_SUBSTITUTION,
        payload: null
    };
}

export function cancelSubstitution() {
    return {
        type: CANCEL_SUBSTITUTION,
        payload: null
    };
}

export function makeSubstitution(player) {
    return {
        type: REPLACE_WITH_THIS_PLAYER,
        payload: player
    };
}

export function resetTeamData() {
    return {
        type: RESET_TEAM_DATA,
        payload: null
    };
}

export function resetCreateTeamError() {
    return {
        type: RESET_CREATE_TEAM_ERROR,
        payload: null
    };
}

export function removeAll() {
    return {
        type: REMOVE_ALL,
        payload: null
    };
}

export function isMatchDetailsLoading(bool) {
    return {
        type: IS_MATCH_DETAILS_LOADING,
        payload: bool
    };
}

export function matchDetailsHasError(bool) {
    return {
        type: MATCH_DETAILS_HAS_ERROR,
        payload: bool
    };
}

export function matchDetailsFetchDataSuccess(matchdetails) {
    return {
        type: MATCH_DETAILS_FETCH_DATA_SUCCESS,
        payload: matchdetails
    };
}

export function getMatchDetails(matchID) {
    let params = {
        optType: 1,
        langCode: config.CURRENT_LANGUAGE,
        matchId: matchID,
    };
    return (dispatch) => common.makeAPICall(matchDetailsAPI, dispatch, isMatchDetailsLoading, matchDetailsFetchDataSuccess, matchDetailsHasError, params);
}


// WEBPACK FOOTER //
// ./src/actions/ManageTeamActions.js